import { create } from 'zustand';
import apiClient from '../api/client';
import Alertas from '../alerts/AlertasGernericos';
import { useProdutosStore } from './ProdutosStore';
import { useVendasStore } from './VendasStore';
import { useTerminaltore } from './TerminaisStores';
import { useCryptoStore } from './CriptoStore';

export const useAuthStore = create((set, get) => ({

    carregando: false,
    logado: false,
    progresso: 'Login',
    nome_do_usuario: '',

    login: async (nome, senha, navigate) => {
        try {
            const { GetProdutosHanking , FiltrarProdutosParaGrafico} = useProdutosStore.getState();
            const { GetVendas } = useVendasStore.getState();
            const { GetEstatisticasDosTerminais } = useTerminaltore.getState();

            set({ carregando: true, progresso: "Buscando usuário" });

            const loginResponse = await apiClient.post('/DashboardLogin',
                { senha: senha, nome: nome }
            );

            const token = loginResponse.data.token;
            await localStorage.setItem('tk', token)
            apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            const boas_vindas = loginResponse.data.message


            if (!loginResponse) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            set({ progresso: "Buscado produtos", nome_do_usuario: nome })

            // await GetProdutosHanking();

            set({ progresso: "Buscado ultimas vendas" })

            // await GetVendas();

            set({ progresso: "Buscado terminais" })

            // await GetEstatisticasDosTerminais();

            set({ progresso: "Buscando venas por produtos" })

            // await FiltrarProdutosParaGrafico()
            // await FiltrarProdutosParaGrafico('');

            Alertas.ExibirAlertaSucesso(`${boas_vindas}`)

            set({ carregando: false });
            set({ logado: true });
            navigate('/Home');

        } catch (err) {
            set({ carregando: false, progresso: 'Login' });
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        } finally {
            set({ carregando: false, progresso: 'Login' });
        }
    },

    logout: async () => {
        set({ logado: false });
    },

}));
